export default class LogEntry {

  /**
   * @param {string} date
   * @param {string} type
   * @param {string} thread
   * @param {string} logger
   * @param {string} message
   */
  constructor(date, type, thread, logger, message) {

    /**
     * @type {String}
     */
    this.date = date;
    /**
     * @type {String}
     */
    this.type = type;
    /**
     * @type {String}
     */
    this.thread = thread;
    /**
     * @type {String}
     */
    this.logger = logger;
    /**
     * @type {String}
     */
    this.message = message;
  }
}
